import { Box, styled } from '@mui/material';
import { theme } from '../../../../../theme';

export const EditTitleBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: theme.spacing(2, 3),
  borderRadius: '10px',
  width: 500,
  outline: 'none',
  border: 'none'
});
